import { useEffect, useMemo } from "react";
import AutocompleteFormik from "../../../../../common/components/form/AutocompleteFormik";
import { getIn, useFormikContext } from "formik";

type Props = {
  name: string;
  className?: string;
}

export function AvailableDocumentLeadsTypesFormik(props: Props) {
  const { values, setFieldValue } = useFormikContext();
  const currentType = getIn(values, props.name)
  const currentComboboxValue = getIn(values, `${props.name}-combobox`)

  const options = useMemo(() => {
    const dataOptions = [
      { label: 'Frente da CNH' },
      { label: 'Verso da CNH' },
      { label: 'Comprovante de Endereço (de até 90 dias)' },
      { label: 'Selfie segurando a CNH' },
      { label: 'Print do Cadastro de App de Entrega' },
      { label: 'Contato de Referência 1 (Print)' },
      { label: 'Contato de Referência 2 (Print)' },
      { label: 'Contato de Referência 3 (Print)' },
      { label: 'Print Detran da Pontuação da CNH' },
    ]
    return dataOptions
  }, [])

  useEffect(() => {
    if (currentComboboxValue && currentType !== currentComboboxValue.label) {
      setFieldValue(props.name, currentComboboxValue.label)
    }
  }, [currentComboboxValue]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (currentType !== (currentComboboxValue && currentComboboxValue.label)) {
      setFieldValue(`${props.name}-combobox`, { label: currentType })
    }
  }, [currentType]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <AutocompleteFormik
      className={props.className}
      label="Tipo de documento:"
      name={`${props.name}-combobox`}
      valueProperty="label"
      options={options}
    />
  )
}
